module.exports = ".ulPP{\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n.swal2-popup .swal2-title{\r\n    line-height: 26px !important;\r\n}\r\n\r\n/* \r\n.multiselect-dropdown[_ngcontent-c5] .dropdown-btn[_ngcontent-c5] .dropdown-multiselect__caret[_ngcontent-c5] {\r\n    height: 30px !important;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main